import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import BarraInferiorBotoes from '../../../../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../../../../components/ContainerConteudo';
import CustomCol from '../../../../../../../components/CustomCol';
import CustomRow from '../../../../../../../components/CustomRow';
import Input from '../../../../../../../components/InputNew';
import SelectInput from '../../../../../../../components/InputNew/Select';
import StyledLink from '../../../../../../../components/Link';
import Log from '../../../../../../../components/Log/Log';
import SubAbas from '../../../../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../../../components/WorkspaceFicha';
import { getUser } from '../../../../../../../modules/contexts/Auth/RequireAuth';
import { useComponentesPaf } from '../../../../../../../services/enum/useComponentesPaf';
import { useStatusOrgInter } from '../../../../../../../services/enum/useStatusOrgInter';
import { getOrgInter } from '../../../../../../../services/orgInters/orgIntersService';
import {
  formataNomeMeioSiglas,
  formatDateSimp,
} from '../../../../../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
  swalAttention,
} from '../../../../../../../utils/swal';
import SubAbasOrgInters from '../../../utils/subabasEntregaFornecedor';
import ItemEntregaPlano from '../planoEntrega';

export default function EntregaFornecedorFicha() {
  //DADOS USUARIO
  const user = getUser();
  const userID = user.sub;

  //COMPONENTE
  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);
  const location = useLocation();
  const locationData = location.state;
  let logs = {};
  let subAbas = [];

  //OPTIONS
  const statusOrgInter = useStatusOrgInter();
  const componenteAF = useComponentesPaf();
  const orgSiglaOptions = [
    { value: 0, label: 'Não informado' },
    { value: 1, label: 'OPAS' },
  ];
  const orgNomeOptions = [
    { value: 0, label: 'Não informado' },
    { value: 1, label: 'Organização Pan-Americana da Saúde' },
  ];
  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });
  const [formOrgInter, setFormOrgInter] = useState({
    usuarioId: userID,
    statusOrgInter: 0,
    componenteAf: locationData ? locationData.userComponenteAf : 0,
    numeroTC: '',
    numeroTermoAjuste: '',
    nupTermoAjuste: '',
    dataInicio: '',
    dataVigencia: '',
    orgNome: '',
    orgSigla: '',
    observacoes: '',
  });

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registroData = await getOrgInter(id);

      setLogData(registroData);

      const dataInicio = registroData.dataInicio
        ? new Date(registroData.dataInicio).toISOString().split('T')[0]
        : '';

      const dataVigencia = registroData.dataVigencia
        ? new Date(registroData.dataVigencia).toISOString().split('T')[0]
        : '';
      setFormOrgInter({
        usuarioId: userID,
        statusOrgInter: Number(registroData.statusOrgInter),
        componenteAf: Number(registroData.componenteAf),
        numeroTC: registroData.numeroTC,
        numeroTermoAjuste: registroData.numeroTermoAjuste,
        nupTermoAjuste: registroData.nupTermoAjuste,
        dataInicio: dataInicio,
        dataVigencia: dataVigencia,
        orgNome: String(
          orgNomeOptions.find((opt) => opt.label === registroData.orgNome)
            ?.value ?? 0,
        ),
        orgSigla: String(
          orgSiglaOptions.find((opt) => opt.label === registroData.orgSigla)
            ?.value ?? 0,
        ),
        observacoes: registroData.observacoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //USE EFFECT
  const [statusStyle, setStatusStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const laranja = '#faca71dd';
    const amarelo = '#faffb4dd';
    const azul = '#acbaff';

    const status = String(formOrgInter.statusOrgInter);

    const newStatusStyle = {
      backgroundColor:
        status === '1'
          ? amarelo
          : status === '2'
            ? azul
            : status === '3'
              ? verde
              : status === '4'
                ? laranja
                : status === '5'
                  ? vermelho
                  : 'white',
    };

    setStatusStyle(newStatusStyle);
  }, [formOrgInter.statusOrgInter]);

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasOrgInters(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/proaq/orginters/ficha/dadosgerais`,
      },
    ];
  }

  //CRUD
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;
    setFormOrgInter((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.statusOrgInter) {
      errors.push('<b>Status</b> é obrigatório.');
    }

    if (!form.numeroTC) {
      errors.push('<b>Número do TC</b> é obrigatório.');
    }

    if (!form.numeroTermoAjuste) {
      errors.push('<b>Número do Termo de Ajuste</b> é obrigatório.');
    }

    if (!form.nupTermoAjuste) {
      errors.push('<b>NUP do Termo de Ajuste</b> é obrigatório.');
    }

    if (form.statusOrgInter > 1) {
      if (!form.dataInicio) {
        errors.push('<b>Data de Início</b> é obrigatório.');
      }

      if (!form.dataVigencia) {
        errors.push('<b>Data de Vigência</b> é obrigatório.');
      }
    }

    if (!form.orgSigla) {
      errors.push('<b>Sigla da Organização Internacional</b> é obrigatório.');
    }

    if (!form.orgNome) {
      errors.push('<b>Nome da Organização Internacional</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>'));
      return false;
    }

    return true;
  };

  const adjustFormOrgInterBeforeSubmit = (formOrgInter: any) => {
    const adjustedForm = {
      ...formOrgInter,
      statusOrgInter: Number(formOrgInter.statusOrgInter),
      dataInicio: formOrgInter.dataInicio
        ? new Date(formOrgInter.dataInicio)
        : null,
      dataVigencia: formOrgInter.dataVigencia
        ? new Date(formOrgInter.dataVigencia)
        : null,
      //Organização Internacional
      orgSigla: orgSiglaOptions[Number(formOrgInter.orgSigla)].label,
      orgNome: orgNomeOptions[Number(formOrgInter.orgNome)].label,

      //Observações
      observacoes:
        formOrgInter.observacoes === ''
          ? 'Sem observações específicas.'
          : formOrgInter.observacoes,
    };

    return adjustedForm;
  };

  const handleCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formOrgInter);
      if (!isFormValid) return;

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormOrgInterBeforeSubmit(formOrgInter);

      // const token = 'JWT_SECRET';
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/orginter/`,
        adjustedForm,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/proaq/orginters/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (axios.isAxiosError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formOrgInter);
      if (!isFormValid) return;

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormOrgInterBeforeSubmit(formOrgInter);

      const token = localStorage.getItem('token');
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/api/orginter/${fichaID}`,
        adjustedForm,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        const token = localStorage.getItem('token');
        await axios.delete(
          `${process.env.REACT_APP_API_URL}/api/orginter/${fichaID}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        swalDeleteConfirm();
        navigate('/daf/proaq/orginters');
      } catch (error) {
        if (axios.isAxiosError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  const [nomeComponente, setNomeComponente] = useState<string>('');
  useEffect(() => {
    const label = componenteAF[formOrgInter.componenteAf]?.label?.toLowerCase();
    if (label === 'básico') setNomeComponente('basico');
    else if (label === 'especializado') setNomeComponente('especializado');
    else if (label === 'estratégico') setNomeComponente('estrategico');
  }, [formOrgInter.componenteAf]);

  //USE EFFECT
  useEffect(() => {
    const { dataInicio, dataVigencia } = formOrgInter;

    if (dataInicio && dataVigencia) {
      const dtInicio = new Date(dataInicio);
      const dtTermino = new Date(dataVigencia);

      if (dtTermino < dtInicio) {
        setFormOrgInter((prev) => ({
          ...prev,
          dataVigencia: '',
        }));
        swalAttention(
          `A data de <b>INÍCIO</b> ${formatDateSimp(dataInicio)} <b><span style="color:red">não pode ser anterior</span></b> à data de <b>VIGÊNCIA</b> ${formatDateSimp(dataVigencia)}.`,
        );
      }
    }
  }, [formOrgInter.dataInicio, formOrgInter.dataVigencia]);

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/proaq/orginters"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} entity="TB_ORG_INTER" id={Number(fichaID)} />

          {/* Identificação do Processo de Aquisição */}
          <BoxConteudo boxTitulo="Identificação da Entrega">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="200px">
                <SelectInput
                  name="statusOrgInter"
                  options={statusOrgInter}
                  label="Status"
                  value={formOrgInter.statusOrgInter}
                  onChange={handleChange}
                  style={statusStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="tipoEntrega"
                  options={statusOrgInter}
                  label="Tipo de Entrega"
                  value={formOrgInter.statusOrgInter}
                  onChange={handleChange}
                  style={statusStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="tipoEntrega"
                  options={statusOrgInter}
                  label="Tipo de Aquisição"
                  value={formOrgInter.statusOrgInter}
                  onChange={handleChange}
                  style={statusStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  id="componenteAf"
                  name="componenteAf"
                  value={''}
                  label="Numeração da Entrega"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol>
                <SelectInput
                  name="tipoEntrega"
                  options={statusOrgInter}
                  label="Instrumento de Aquisição"
                  value={formOrgInter.statusOrgInter}
                  onChange={handleChange}
                  style={statusStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="120px">
                <Input
                  id="componenteAf"
                  name="componenteAf"
                  value={componenteAF[formOrgInter.componenteAf]?.label}
                  label="ID Aquisição"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
            </CustomRow>

            <CustomRow>
              <CustomCol width="275px">
                <Input
                  id="componenteAf"
                  name="componenteAf"
                  value=""
                  label="Qtd Prevista"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="275px">
                <Input
                  id="componenteAf"
                  name="componenteAf"
                  value=""
                  label="Qtd Entregue"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="120px">
                <Input
                  id="componenteAf"
                  name="componenteAf"
                  value=""
                  label="% Entregue"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="170px">
                <Input
                  id="componenteAf"
                  name="componenteAf"
                  value=""
                  label="Fator Embalagem"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="140px">
                <Input
                  id="componenteAf"
                  name="componenteAf"
                  value=""
                  label="Nº Embalagens"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="300px">
                <Input
                  id="componenteAf"
                  name="componenteAf"
                  value=""
                  label="Valor Unitário R$"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Input
                  id="componenteAf"
                  name="componenteAf"
                  value=""
                  label="Valor Total R$"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <ItemEntregaPlano />

          {/* Observações */}
          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formOrgInter.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDelete}
            save
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
